module.exports = __webpack_public_path__ + "img/5-4.de1028b5.svg";